import React from 'react';
import CaltureContentsRightItem from './CaltureContentsRightItem'
import calture_contents_left_bg from '../images/calture-contents-left-bg.jpg'
import './Calture.css'
import GroupTitle, {GroupTitileOrange, GroupTitleBackground, GroupTitleText} from "./GroupTitle";

export default function Calture(){
   return(
        <div className='calture'>
           <GroupTitle>
              <GroupTitleBackground>culture</GroupTitleBackground>
              <GroupTitleText>
                 <span>企业</span>
                 <GroupTitileOrange>文化</GroupTitileOrange>
              </GroupTitleText>
           </GroupTitle>
           <div className='calture-contents'>
              <div className='calture-contents-left'>
                 <img src={calture_contents_left_bg} alt='calture-contents-left-bg'/>
                 <p className='calture-contents-left-text1'>
                    创新的思维
                 </p>
                 <p className='calture-contents-left-text2'>
                    坚持
                 </p>
                 <p className='calture-contents-left-text3'>
                    勇于实践
                 </p>
              </div>
              <div className='calture-contents-right'>
                 <CaltureContentsRightItem className="calture-contents-right-1"> 正义：成正直的人，做正义的事。</CaltureContentsRightItem>
                 <CaltureContentsRightItem className="calture-contents-right-2"> 尊重：尊重技术、尊重数据、尊重客户、尊重事业。</CaltureContentsRightItem>
                 <CaltureContentsRightItem className="calture-contents-right-3"> 自信：信任企业，树立自信，充满激情。</CaltureContentsRightItem>
                 <CaltureContentsRightItem className="calture-contents-right-4"> 创新：锐意进取，敢于实践，成就新技术。</CaltureContentsRightItem>
                 <CaltureContentsRightItem className="calture-contents-right-5"> 共享：分享他人，合作共赢，成就自我。</CaltureContentsRightItem>
                 <CaltureContentsRightItem className="calture-contents-right-6"> 主动：为自己而工作，与企业共成长，实现财务自由。</CaltureContentsRightItem>
              </div>
           </div>
        </div>
   )
}